import React, { Component } from "react";
import { InputField } from "../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from "../../../common/custom-form/custom-date-picker.component";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { ListTabButton } from "../../../common/list-tab/list-tab-button.component";
import { AddPlanDetails } from "./add-plan-details.component";
import { AddSim } from "./add-sim.component";
import { AddEquipment } from "./add-equipment.component";
import { AddCostAllocation } from "./add-cost-allocation.component";
import  InvoiceHistory from "../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
import InvoiceComment from "../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import { InventoryConfirmation } from "../modal/inventory-confirmation.component";
import { AddAddressDetails1 } from "./add-address1.component";
import ButtonIcon from "../../../button";
import { AddAddressDetails2 } from "./add-address2.component";
import { Selected_Index } from "../../../../constants/internal-constants";
import { DetailsDataTable } from "./details-table/details-table.component";
import { AccessInfo } from "./access-information.component";
import { PIPInfo } from "./pip-information.component";
import Icon from "../../../icon";
import  MobileChangeUserForm from "../../../external/request/request-form/wireless/wireless-change-user.component"
import { TakeActionModal } from "./modal/take-action-modal.component";
import { DetailsInfo } from "../modal/detail-info-modal";
export class InventoryDetails extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            installDate: "",
            selectedIndex: "0",
            showSimDetails: false,
            showEquipmentDetails:false,
            showPlanDetails:false,
            showTakeActionModal:false,
            showTakeAction:false,
            modalType:'',
            takeActionItem:[                
                "Change User",
                "Change Price Plan",
                "Change Vendor",
                "Replace Sim",
                "International Roaming Access",
                "Replace Device",
                "Accessory",
                "Terminate Subscription",
                "Port Out",
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }, {
                            name:"Service Type"
                        }, {
                            name:"Effective Date"
                        }
                    ],
                    dataItem:[{            
                        "Contract Name": "3G Hutchison (GB) Contract",
                        "Vendor": "3G Hutchison (GB)",
                        "Status": "Expired",
                        "Service Type": "Telecommunications",
                        "Effective Date": "May 29, 2021",                        
                    }        
                    ]
    
                }
            ],
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
        }
    }

    FilterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex});  
       
    }

    CloseForm() {
        this.props.closeForm(false)
    }

    ShowSimDetails(value) {
        this.setState({showSimDetails:value})
    }

    ShowEquipmentDetails(value) {
        this.setState({showEquipmentDetails:value})
    }

    ShowPlanDetails(value) {
        this.setState({showPlanDetails:value})
    }

    handleTakeActionModal (modalType){
        this.setState({ showTakeActionModal: true, modalType });
    };

    handleTakeActionModalClose () {
        this.setState({ showTakeActionModal: false, modalType: '' });
    };

    handleShowTakeAction(){

        this.setState({showTakeAction:!this.state.showTakeAction}, () => {
            if (this.state.showTakeAction) {
                document.addEventListener('click', this.handleOutsideClick);
            } else {
                document.removeEventListener('click', this.handleOutsideClick);
            }
        })
    }

    handleOutsideClick = (e) => {
        if (e.target.closest('.create-request-children') || e.target.closest('.icon-nav')) {
            return;
        }
        this.setState({ showTakeAction: false });
        document.removeEventListener('click', this.handleOutsideClick);
    };

    render(){
        return(
            <div className="remove-background inventory-internal-table request-table-invoice">
             <ButtonIcon onClick={this.CloseForm.bind(this)} iconLeft="chevron-left" iconSize="17px" customClassName="manage-invoice-back-button" labelName="Back"/> 
             <ListTabButton listData={this.state.listTabInfo.Tab} selectedIndex={this.props.haveTotalDetail ? this.state.selectedTab : this.state.selectedIndex} FilterIndex={this.FilterIndex.bind(this)}/>
            {
                this.state.selectedIndex === Selected_Index.i_Zero &&
                <div>
                    <div className="details-container">               
                    <div className="details-field-container">
                        <div className="detail-with-icon-container">
                            <Icon
                                name="ellipsis"
                                size="18px"
                                customClassName="icon-nav"            
                                containerClass="info-container" 
                                onClick={this.handleShowTakeAction.bind(this)}                              
                            />
                           <div className={`create-request-children ${this.state.showTakeAction ? 'Active' : ""}`}>
                                <span>ACTIONS</span>
                                {this.state.takeActionItem.map((list,index)=>
                                    <TakeActionModal key={index} modalType={list} onClick={()=>this.handleTakeActionModal(list)} />                                  
                                )}                               
                           </div>
                            <InputField label="CIRCUIT ID" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        </div>
                        <SelectField label="STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                        <SelectField label="CIRCUIT PARKING"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                        <SelectField label="LINK PRIMARY CIRCUIT"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                        <div className="detail-with-icon-container">
                          <DetailsInfo title="Account Details" costAllocationData={this.state.dataTable} circuitData={this.state.dataTable}/>
                          <SelectField label="BILLING ACCOUNT #"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                        </div> 
                        <InputField label="ACCOUNT TYPE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        <InputField label="CLIENT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        <InputField label="VENDOR" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />                      
                        <div className="detail-with-icon-container">
                          <DetailsInfo title="User Details" costAllocationData={this.state.dataTable} circuitData={this.state.dataTable}/>
                          <SelectField label="USER/HR ID"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                        </div>
                        <InputField label="USER NAME" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        <InputField label="EMAIL ADDRESS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        <SelectField label="LINE MANAGER"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>  
                        <DATEPICKER_OR label="INSTALL DATE" startDate={this.state.installDate} dateSelected={this.state.installDate} selectedDate={(date) => this.setState({installDate:date})}/>
                        <DATEPICKER_OR label="DISCONNECT DATE" startDate={this.state.installDate} dateSelected={this.state.installDate} selectedDate={(date) => this.setState({installDate:date})}/>      
                        <DATEPICKER_OR label="SUSPENSION PERIOD" startDate={this.state.installDate} dateSelected={this.state.installDate} selectedDate={(date) => this.setState({installDate:date})}/>   
                        <div></div>
                        <InputField label="MRC" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                        <InputField label="CIRCUIT RANKING" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />                       
                    </div>
                    <div className="horizontal-separator"></div>
                    <CustomDropdown label="Location Address 1">
                        <AddAddressDetails1 selectFilter={this.state.selectFilter} />
                    </CustomDropdown>
                    
                    <CustomDropdown label="Location Address 2">
                        <AddAddressDetails2 selectFilter={this.state.selectFilter}/>
                    </CustomDropdown>

                    <CustomDropdown label="Access Information">
                        <AccessInfo selectFilter={this.state.selectFilter}/>
                    </CustomDropdown>

                    <CustomDropdown label="PIP Information">
                        <PIPInfo selectFilter={this.state.selectFilter}/>
                    </CustomDropdown>
                    
                    <CustomDropdown label="Add Plan Details">
                        <AddPlanDetails selectFilter={this.state.selectFilter} datatable={this.state.dataTable} showDetails={this.ShowPlanDetails.bind(this)} />
                    </CustomDropdown>
                    {this.state.showPlanDetails &&
                        <div className="details-table-container add-sim-container">
                            <DetailsDataTable classNameWrapper="table-details-wrapper" datatable={this.state.dataTable}  haveExternalDeleteBtn={true}/>
                        </div>                             
                    }

                    <CustomDropdown label="Add Sim">
                        <AddSim selectFilter={this.state.selectFilter} showDetails={this.ShowSimDetails.bind(this)} />
                    </CustomDropdown>   
                    {this.state.showSimDetails &&
                        <div className="details-table-container add-sim-container">
                            <DetailsDataTable classNameWrapper="table-details-wrapper" datatable={this.state.dataTable}  haveExternalDeleteBtn={true}/>
                        </div>                             
                    }
                   
                    <CustomDropdown label="Add Equipment">
                        <AddEquipment selectFilter={this.state.selectFilter} showDetails={this.ShowEquipmentDetails.bind(this)}/>
                    </CustomDropdown>
                    {this.state.showEquipmentDetails &&
                        <div className="details-table-container add-sim-container">
                            <DetailsDataTable classNameWrapper="table-details-wrapper" datatable={this.state.dataTable}  haveExternalDeleteBtn={true}/>
                        </div>                             
                    }

                    <CustomDropdown label="Add Cost Allocation">
                        <AddCostAllocation datatable={this.state.dataTable} haveEditBtn={true} haveDeleteBtn={true}/>
                    </CustomDropdown>                    
                    
                </div>
                    <div className="save-btn-container">                       
                            <InventoryConfirmation />
                    </div>
                </div>                        
            }
            {
                this.state.selectedIndex===Selected_Index.i_One &&
                < InvoiceHistory dataInfo={this.state.dataInfo} noMessage="No History Available"/>
            }

            {
                this.state.selectedIndex===Selected_Index.i_Two &&
                <InvoiceComment dataInfo={this.state.commentData} noMessage="No Comment Available"/>
            }
            </div>
        )
    }
}